<template>
  <div class="boxHelpTypology"  :id="id">
    <img src="@/assets/img/IAReputation/help.svg" @click="showHelpTypology = true" class="cursor-pointer w-[16px]">
    <div v-if="showHelpTypology" class="box">
      <div class="scroll">
        <p>La <span class="font-bold">Taxonomía Tulxy</span> clasifica las fuentes externas para entender cómo los modelos de IA construyen su "visión del mundo" de una marca, más allá del SEO clásico. Tipologías:</p>

        <p class="mt-2"><span class="font-medium">1. Brand Core (Propiedades Oficiales):</span> Son las propiedades digitales oficiales de la marca (web principal, subdominios).
          <span class="text-purple">Para un LLM, es la fuente primaria para aprender qué haces, cómo te defines y cuáles son tus atributos aspiracionales.</span></p>

        <p class="mt-2"><span class="font-medium">2. Brand Extended / Perfiles Controlados:</span> Incluye páginas de terceros donde la marca tiene control directo o casi directo, como fichas en plataformas de delivery, reservas o centros comerciales.
          <span class="text-purple">Refuerzan la existencia real y la distribución geográfica de la marca.</span>
        </p>

        <p class="mt-2"><span class="font-medium">3. Review & UGC Platforms:</span> Plataformas donde los usuarios generan contenido (reseñas, valoraciones, comentarios) como Google Reviews o Trustpilot.
          <span class="text-purple">Los modelos infieren el sentimiento, la experiencia del cliente y los atributos espontáneos (ej. lento, amable) a partir de estas fuentes.</span>
        </p>

        <p class="mt-2"><span class="font-medium">4. High-Authority Media:</span> Medios con gran autoridad, como prensa generalista, económica o revistas de prestigio.
          <span class="text-purple">Los LLM confían mucho en ellas y las usan como "prueba fuerte" para afirmar el tamaño, la expansión y el posicionamiento de negocio de la marca.</span>
        </p>

        <p class="mt-2"><span class="font-medium">5. Vertical & Trade Media (Sectoriales):</span> Medios especializados en una industria (Horeca, retail, salud, etc.).
          <span class="text-purple">Son la base para que los LLM definan la categoría de negocio de la marca (ej. "clínica premium") y su autoridad sectorial.</span>
        </p>

        <p class="mt-2"><span class="font-medium">6. Competitors & Category Peers:</span> Dominios de competidores directos o cercanos que el modelo agrupa mentalmente contigo.
          <span class="text-purple">Esto ayuda a construir el mapa mental de la liga competitiva y a analizar si la narrativa de la marca es diferencial o intercambiable.</span>
        </p>
      </div>
    </div>
  </div>

</template>
<script>
export default {
  props: ['show'],
  data() {
    return {
      id: crypto.randomUUID(),
      showHelpTypology: false
    }
  },
  methods: {
    closeDropdownOnOutsideClick() {
      document.addEventListener('click', (e) => {
        if (document.getElementById(this.id) && !document.getElementById(this.id).contains(e.target)) {
          this.showHelpTypology = false
        }
      })
    }
  },
  mounted() {
    this.closeDropdownOnOutsideClick()
  }
}

</script>
<style lang="scss">
.boxHelpTypology{
  position: relative;
  .box{
    position: absolute;
    z-index: 50;
    box-shadow: 0 0 2px #909090;
    background: #fff;
    color: #000;
    border-radius: 8px;
    width: 448px;
    border: 1px solid #949494;
    padding: 3px;
    top: 100%;
    font-weight: normal;
    .scroll{
      font-size: 12px;
      max-height: 300px;
      overflow-y: auto;
      padding: 8px 12px;
    }
  }
}
</style>
